import { render, staticRenderFns } from "./TimelinesElement.vue?vue&type=template&id=f4b7e54c&scoped=true&"
import script from "./TimelinesElement.vue?vue&type=script&lang=js&"
export * from "./TimelinesElement.vue?vue&type=script&lang=js&"
import style0 from "./TimelinesElement.vue?vue&type=style&index=0&id=f4b7e54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b7e54c",
  null
  
)

export default component.exports